import React, {useState} from 'react';
import axios from "axios";
import {Button, Upload} from "antd";
import {UploadOutlined} from "@ant-design/icons";
import cookie from "react-cookies";

function BaseFileUpload({data, span, callback,type}) {

  const [status,setStatus] = useState(true);

  const [fileList,setFileList] = useState([])

  const handleFileUpload = async (file) => {

    const formData = new FormData();

    formData.append('file', file);
    formData.append('dataString', JSON.stringify(data));
    try {
      await axios.post(process.env.REACT_APP_URL + '/baseApi/baseFileUpload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + cookie.load("token")
        }
      }).then(res => {
        if (res.data.status === 200) {
          setFileList([file])
          callback(res.data.data)
        }
      });
      console.log('文件上传成功');
    } catch (error) {
      console.error('文件上传失败: ', error);
    }
  };


  return (
    <>
      <Upload
        // beforeUpload={status}
        customRequest={({file}) => handleFileUpload(file)}
        showUploadList={type==='reim'?true:false}
        fileList={fileList}
        maxCount={1}
        // listType="picture"
        // className='upload-list-inline'
        // listType={type==='reim' ? 'picture' : null}
        // className={type==='reim' ? 'upload-list-inline' : null}
      >
        {type ==='reim'?
          <Button  style={{marginBottom:'1rem'}} icon={<UploadOutlined />}>{span}</Button>:
          span
        }

        {/*<Button icon={<UploadOutlined />}>上传文件</Button>*/}
      </Upload>
    </>
  )


}

export default BaseFileUpload;
